import React, { Fragment, useEffect, useState } from "react";
import InputField from "../InputField";
import { useRouter } from "next/router";
import PasswordField from "../PasswordField";
import { useMediaQuery } from "react-responsive";
import GoogleLogin from "react-google-login";
import Button from "../Button";
import Icon from "../Icon";
import DropdownC from "../Dropdown";
import ProgressBarComp from "../Progressbar";
import { useSelector } from "react-redux";

const RegistrationForm = ({
  options,
  onChangeDropdown,
  formFields,
  responseSocial,
  dispatcher = false,
  onChange,
  buttonClicked,
  countryCode,
  toSecond,
}) => {
  const router = useRouter();

  const { dot } = useSelector((state) => state.auth);
  const isDesktopOrLaptop = useMediaQuery({
    minWidth: "1224px",
    maxWidth: "1823px",
  });
  const isBigScreen = useMediaQuery({ minWidth: "1824px" });
  const isTablet = useMediaQuery({ minWidth: "481px", maxWidth: "1223px" });
  const Mobile = useMediaQuery({ query: "(max-width: 480px)" });
  const { withOutDot: noDot } = router.query;
  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsBig(isBigScreen);
      setIsDesk(isDesktopOrLaptop);
      setIsTab(isTablet);
    }
  }, [isBigScreen, isTablet, isDesktopOrLaptop]);

  const [isBig, setIsBig] = useState(null);
  const [isDesk, setIsDesk] = useState(null);
  const [isTab, setIsTab] = useState(null);
  const [progressVal, setProgressVal] = useState(0);

  let withOutDotStorage = localStorage.getItem("withOutDot");

  function loadSteps() {
    if (dot === "" && !noDot) {
      // setProgressVal(25);
      return "4";
    } else if (dot !== "") {
      // setProgressVal(33.3);
      return "3";
    } else if (dot === "" && noDot) {
      // setProgressVal(50);
      return "2";
    }
  }

  useEffect(() => {
    if (noDot) {
      if (dot === "" && noDot) {
        setProgressVal(50);
      }
    }
  }, [router.query]);

  useEffect(() => {
    if (dot === "" && !withOutDotStorage) {
      setProgressVal(25);
    } else if (dot !== "") {
      setProgressVal(33.3);
    } else if (dot === "" && withOutDotStorage) {
      setProgressVal(50);
    }
  }, []);
  return (
    <div
      className={`flex flex-col ${isBig ? " px-60" : isDesk ? "px-32" : isTab ? "px-10" : "px-5"} gap-y-5 ${
        toSecond && " duration-200  transform -translate-x-full  ease-out"
      } min-h-screen `}
    >
      <div className=" flex flex-row gap-x-2 items-center" onClick={() => router.push("/")}>
        <Icon name={"icon-backInactive"} />
        <h3 className="text-blue5 font-hkMedium">Back</h3>
      </div>
      <div className=" flex flex-row items-center gap-x-5">
        <div className=" w-4/5">
          <ProgressBarComp value={progressVal} />{" "}
        </div>

        <h3 className=" text-bgActiveButton whitespace-nowrap font-hkMedium">Step 1 of {loadSteps()}</h3>
      </div>
      {!dispatcher ? (
        <h3 className={`text-gray3 font-SpaceBold xs:text-lg sm:text-xl xl:text-4xl `}>
          Create your{" "}
          <span className=" text-bgActiveButton">
            {process.env.NEXT_PUBLIC_THEME === "LT" ? "LuckyTruck" : "Flexport Insurance"}
          </span>
          &nbsp;account to get started
        </h3>
      ) : (
        <h3 className={`text-gray3 font-hkBold xs:text-lg sm:text-xl xl:text-4xl `}>Dispatcher Signup</h3>
      )}
      <h3 className="text-lg font-interMedium text-bgInactiveButton">
        {!dispatcher
          ? "Get the best insurance quote for you in just a few minutes"
          : "Enter your personal details here"}
      </h3>
      <div className=" border-t-2 border-dividerColor opacity-50 mt-3  w-full " />
      {/* <div
        className={` flex ${
          isTab ? "flex-col space-x-0 gap-y-5 " : "flex-row space-x-8"
        }   mt-2`}
      >
        
      </div> */}
      <InputField
        width={"w-full"}
        height={"h-14"}
        name={"firstName"}
        error={formFields.firstName.error}
        value={formFields.firstName.value}
        message={formFields.firstName.message}
        onInputChange={onChange}
        placeholder="First Name"
      />
      <InputField
        width={"w-full"}
        height={"h-14"}
        placeholder="Last Name"
        name={"lastName"}
        value={formFields.lastName.value}
        error={formFields.lastName.error}
        message={formFields.lastName.message}
        onInputChange={onChange}
      />
      <DropdownC
        placeholder="Country Code"
        value={countryCode}
        width={"w-full"}
        options={options}
        onChange={onChangeDropdown}
      />
      <InputField
        width={"w-full"}
        height={"h-14"}
        placeholder="Phone"
        name={"phone"}
        value={formFields.phone.value}
        error={formFields.phone.error}
        message={formFields.phone.message}
        onInputChange={onChange}
      />

      <InputField
        width={"w-full"}
        height={"h-14"}
        placeholder="Email"
        name={"email"}
        value={formFields.email.value}
        error={formFields.email.error}
        message={formFields.email.message}
        onInputChange={onChange}
      />
      {/* <div
        className={` flex ${
          isTab ? "flex-col space-x-0 gap-y-5 " : "flex-row space-x-8   "
        }   mt-2`}
      >
        <DropdownC
          placeholder="Country Code"
          value={countryCode}
          width={isTab ? "w-full" : "w-rg2"}
          options={options}
          onChange={onChangeDropdown}
        />
       
      </div> */}

      <PasswordField
        width={"w-full"}
        height={"h-14"}
        onInputChange={onChange}
        value={formFields.password.value}
        message={formFields.password.message}
        error={formFields.password.error}
      />
      <Button
        title={!dispatcher ? "SIGN UP" : "SUBMIT"}
        width="w-full"
        height="h-14"
        onButtonClick={buttonClicked}
        disabled={formFields.disabled}
      />
      {formFields.mainError ? <h5 className=" errorMessage">{formFields.mainErrorMessage}</h5> : null}
      {!dispatcher ? (
        <div className={` flex flex-row space-x-4  mt-2`}>
          <div className=" border-t-2 border-dividerColor opacity-50 mt-3 w-1/2 mb-5" />
          <h3 className="whitespace-nowrap text-sm text-center text-signUpTextColor font-interMedium">Or</h3>
          <div className=" border-t-2 border-dividerColor opacity-50 mt-3 w-1/2" />
        </div>
      ) : null}
      {!dispatcher ? (
        <GoogleLogin
          clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID}
          render={(renderProps) => (
            <div
              className="rounded-xl border-custom border-borderColor p-14 text-center flex justify-center items-center space-x-2 cursor-pointer"
              onClick={renderProps.onClick}
            >
              <Icon name="icon-google" />
              <h3 className=" font-interMedium text-base">Signup with Google</h3>
            </div>
          )}
          onSuccess={responseSocial}
          onFailure={responseSocial}
          cookiePolicy={"single_host_origin"}
        />
      ) : null}
      {/* {!dispatcher ? (
        <FacebookLogin
          appId={process.env.NEXT_PUBLIC_FACEBOOK_APP_ID}
          fields="name,email,picture"
          render={({ onClick, logout }) => (
            <div
              className="rounded-xl border-custom border-borderColor p-14 text-center flex justify-center items-center space-x-2 mb-2 cursor-pointer"
              onClick={onClick}
            >
              <Icon name="icon-facebook" />
              <h3 className=" font-interMedium text-base">
                Signup with Facebook
              </h3>
            </div>
          )}
          onSuccess={responseSocial}
          onFail={responseSocial}
        />
      ) : null} */}
      <div
        className={!dispatcher ? "mt-auto mb-16 " : "mt-10"}
        onClick={() =>
          !dispatcher
            ? router.push(process.env.NEXT_PUBLIC_USER_LOGIN)
            : router.push(process.env.NEXT_PUBLIC_DISPATCHER_LOGIN)
        }
      >
        <h3 className="font-hkMedium text-lg text-center text-inputColor ">Already have an account?</h3>
        <h3 className="font-hkBold text-lg text-createAcc text-center cursor-pointer">LOGIN</h3>
      </div>
    </div>
  );
};

export default RegistrationForm;
